/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ListContractTemplatesResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'array',
        contains: {
          type: 'ContractTemplate',
        },
        isRequired: true,
      },
    },
  }],
} as const;
